module.exports = __webpack_public_path__ + "img/image5.651695b2.jpg";